import ScrollBox from './ScrollBox'

export default ScrollBox
